import { render, staticRenderFns } from "./localOrderPop.vue?vue&type=template&id=5a55e5de&scoped=true"
import script from "./localOrderPop.vue?vue&type=script&lang=js"
export * from "./localOrderPop.vue?vue&type=script&lang=js"
import style0 from "./localOrderPop.vue?vue&type=style&index=0&id=5a55e5de&prod&scoped=true&lang=css"
import style1 from "./localOrderPop.vue?vue&type=style&index=1&id=5a55e5de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55e5de",
  null
  
)

export default component.exports